export default __webpack_public_path__ + "images/WF.ac38897.png";